// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__167r7","insightsList":"newBusinessInsightsMenu_insightsList__3fXGi","active":"newBusinessInsightsMenu_active__2-SrZ"};